import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CompoffService } from "../../services/CompOffService";
const initialState = {
    columnConfig: [],
    status: 'idle',
    formData: {
        configurationData: {},
        initializedCompOffs: {},
        manageCompOffRequests:{},
        appliedCompOffs: {},
        myAppliedCompOff: {},
        
    },
    leaveTypes:[]
};

export const fetchCompOffSettings = createAsyncThunk('comp-off-settings', async () => {
    const response = await CompoffService.fetchConfigurationSettings();
    return response;
})

export const fetchInitializedCompOffs = createAsyncThunk('initialized-comp-offs', async () => {
    const response = await CompoffService.getInitialisedCompoffsList();
    return response;
})

export const fetchManageCompOffsRequests = createAsyncThunk('manage-comp-offs-request', async () => {
    const response = await CompoffService.fetchInitializedCompOffs();
    return response;
})

export const fetchAppliedCompoffs = createAsyncThunk('applied-comp-offs-request', async () => {
    const response = await CompoffService.getEmployeeCompOffsList();
    return response;
})

export const fetchMyAppliedCompoffs = createAsyncThunk('applied-my-comp-offs', async () => {
    const response = await CompoffService.getEmployeeAppliedCompOffsList();
    return response;
})

export const fetchLeaveType = createAsyncThunk("leaveTypes", async () => {
    return await CompoffService.getLeaveTypes({limit:100,search_field:"leaveStatus",search_string:"Active" })
})

export const CompOffSlice = createSlice({
    name: "compOff",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompOffSettings.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchCompOffSettings.fulfilled, (state, action) => {
                state.status = "idle";
                state.formData.configurationData = action.payload;
            })
            .addCase(fetchInitializedCompOffs.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchInitializedCompOffs.fulfilled, (state, action) => {
                state.status = "idle";
                state.formData.initializedCompOffs = action.payload;
            })
            .addCase(fetchManageCompOffsRequests.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchManageCompOffsRequests.fulfilled, (state, action) => {
                state.status = "idle";
                state.formData.manageCompOffRequests = action.payload;
            })
            .addCase(fetchAppliedCompoffs.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchAppliedCompoffs.fulfilled, (state, action) => {
                state.status = "idle";
                state.formData.appliedCompOffs = action.payload;
            })
            .addCase(fetchMyAppliedCompoffs.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchMyAppliedCompoffs.fulfilled, (state, action) => {
                state.status = "idle";
                state.formData.myAppliedCompOff = action.payload;
            })
            .addCase(fetchLeaveType.pending , (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLeaveType.fulfilled, (state,action)=>{
                state.status = 'idle';
                state.leaveTypes = action.payload
            })
    }
})

export const selectConfigurationSettings = (state) => state.compOff.formData.configurationData;

export const selectInitializedCompOffs = (state) => state.compOff.formData.initializedCompOffs;

export const selectManageCompOffRequests = (state) => state.compOff.formData.manageCompOffRequests;

export const selectAppliedCompOffRequests = (state) => state.compOff.formData.appliedCompOffs;

export const selectMyAppliedCompOffRequests = (state) => state.compOff.formData.myAppliedCompOff;

export const selectLeaveTypes = (state) => state.compOff.leaveTypes;

export default CompOffSlice.reducer;